'use client';

import NumberFlow from '@number-flow/react';
import Decimal from 'decimal.js';
import { useEffect, useRef } from 'react';
import { Numeric } from '@/lib/types/common';

interface AnimatedPercentTextProps {
  value: Numeric;
  decimals?: number;
  className?: string;
}

export function AnimatedPercentText({ value, decimals = 0, className }: AnimatedPercentTextProps) {
  const isFirstRender = useRef(true);

  useEffect(() => {
    isFirstRender.current = false;
  }, []);

  const raw = Number(value ?? 0);
  const safeValue = Number.isNaN(raw) ? 0 : raw;
  const percentValue = Number(new Decimal(safeValue).mul(100));

  return (
    <NumberFlow
      value={percentValue}
      suffix="%"
      format={{
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      }}
      locales="en-US"
      animated={!isFirstRender.current}
      className={className}
      willChange
    />
  );
}
